// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BKoc","select":"styles_select__2ghy1"};